var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 48,
    viewBox: "0 0 162 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599115,
    y: 0.599115,
    width: 160.563,
    height: 46.731,
    rx: 6.59026,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.599115,
    y: 0.599115,
    width: 160.563,
    height: 46.731,
    rx: 6.59026,
    stroke: "#A6A6A6",
    strokeWidth: 1.19823
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6445 26.0623C78.8263 26.0623 76.5293 28.2059 76.5293 31.1583C76.5293 34.0928 78.8263 36.2544 81.6445 36.2544C84.464 36.2544 86.761 34.0928 86.761 31.1583C86.7598 28.2059 84.4628 26.0623 81.6445 26.0623ZM81.6445 34.2486C80.1 34.2486 78.7688 32.9748 78.7688 31.1595C78.7688 29.325 80.1012 28.0705 81.6445 28.0705C83.189 28.0705 84.5203 29.325 84.5203 31.1595C84.5203 32.9736 83.189 34.2486 81.6445 34.2486ZM70.4842 26.0623C67.666 26.0623 65.369 28.2059 65.369 31.1583C65.369 34.0928 67.666 36.2544 70.4842 36.2544C73.3036 36.2544 75.6007 34.0928 75.6007 31.1583C75.6007 28.2059 73.3036 26.0623 70.4842 26.0623ZM70.4842 34.2486C68.9397 34.2486 67.6085 32.9748 67.6085 31.1595C67.6085 29.325 68.9409 28.0705 70.4842 28.0705C72.0287 28.0705 73.36 29.325 73.36 31.1595C73.3612 32.9736 72.0287 34.2486 70.4842 34.2486ZM57.2102 27.6271V29.7887H62.3842C62.2296 31.005 61.8246 31.8928 61.2063 32.5099C60.4538 33.2624 59.276 34.0928 57.2102 34.0928C54.0253 34.0928 51.5354 31.525 51.5354 28.3401C51.5354 25.1552 54.0253 22.5874 57.2102 22.5874C58.9285 22.5874 60.183 23.2632 61.1093 24.1319L62.6346 22.6066C61.3405 21.3712 59.6235 20.4258 57.2102 20.4258C52.8475 20.4258 49.1797 23.9773 49.1797 28.3401C49.1797 32.7028 52.8475 36.2544 57.2102 36.2544C59.5647 36.2544 61.3417 35.4815 62.7305 34.0341C64.1588 32.6058 64.6033 30.5976 64.6033 28.9763C64.6033 28.4755 64.565 28.0118 64.4871 27.6259H57.2102V27.6271ZM111.5 29.3059C111.075 28.1675 109.781 26.0623 107.137 26.0623C104.512 26.0623 102.33 28.128 102.33 31.1583C102.33 34.0149 104.492 36.2544 107.387 36.2544C109.723 36.2544 111.074 34.8261 111.635 33.9957L109.898 32.837C109.319 33.6866 108.527 34.2462 107.387 34.2462C106.249 34.2462 105.438 33.7249 104.917 32.7016L111.731 29.8834L111.5 29.3059ZM104.55 31.005C104.492 29.0351 106.075 28.0321 107.215 28.0321C108.103 28.0321 108.855 28.4767 109.107 29.1129L104.55 31.005ZM99.0105 35.9465H101.249V20.9674H99.0105V35.9465ZM95.3415 27.2018H95.2648C94.7627 26.6027 93.797 26.0623 92.582 26.0623C90.0333 26.0623 87.698 28.3017 87.698 31.1787C87.698 34.0353 90.0333 36.2556 92.582 36.2556C93.7982 36.2556 94.7627 35.7152 95.2648 35.0981H95.3415V35.8314C95.3415 37.7809 94.299 38.8234 92.6203 38.8234C91.2495 38.8234 90.4 37.8397 90.0525 37.0093L88.103 37.8205C88.6626 39.1709 90.1484 40.8316 92.6203 40.8316C95.2456 40.8316 97.4659 39.2871 97.4659 35.5223V26.3726H95.3427V27.2018H95.3415ZM92.7749 34.2486C91.2304 34.2486 89.9375 32.9545 89.9375 31.1787C89.9375 29.3825 91.2304 28.0705 92.7749 28.0705C94.299 28.0705 95.4961 29.3825 95.4961 31.1787C95.4961 32.9545 94.299 34.2486 92.7749 34.2486ZM121.989 20.9674H116.632V35.9465H118.866V30.2716H121.988C124.466 30.2716 126.903 28.4779 126.903 25.6201C126.903 22.7623 124.467 20.9674 121.989 20.9674ZM122.046 28.1867H118.866V23.0523H122.046C123.718 23.0523 124.667 24.4363 124.667 25.6201C124.667 26.78 123.718 28.1867 122.046 28.1867ZM135.864 26.0359C134.246 26.0359 132.569 26.7488 131.876 28.3293L133.86 29.1573C134.284 28.3293 135.075 28.0585 135.903 28.0585C137.059 28.0585 138.235 28.7523 138.254 29.9853V30.1398C137.849 29.9086 136.981 29.5623 135.922 29.5623C133.783 29.5623 131.605 30.7377 131.605 32.9341C131.605 34.9387 133.359 36.2292 135.324 36.2292C136.827 36.2292 137.656 35.5546 138.176 34.7638H138.252V35.9201H140.412V30.177C140.413 27.5193 138.426 26.0359 135.864 26.0359ZM135.594 34.245C134.863 34.245 133.841 33.8783 133.841 32.9724C133.841 31.8162 135.113 31.3728 136.212 31.3728C137.193 31.3728 137.657 31.5849 138.254 31.8737C138.08 33.2624 136.885 34.245 135.594 34.245ZM148.274 26.363L145.711 32.8574H145.635L142.975 26.363H140.566L144.555 35.4396L142.281 40.4889H144.613L150.761 26.363H148.274ZM128.137 35.9465H130.372V20.9674H128.137V35.9465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8173 12.2702C56.8173 13.2743 56.5201 14.0736 55.9246 14.6703C55.2488 15.3796 54.3669 15.7343 53.2837 15.7343C52.246 15.7343 51.3629 15.3748 50.638 14.6559C49.9119 13.9358 49.5488 13.0443 49.5488 11.9802C49.5488 10.915 49.9119 10.0235 50.638 9.3046C51.3629 8.58447 52.246 8.225 53.2837 8.225C53.7989 8.225 54.2914 8.32565 54.7587 8.52575C55.2272 8.72706 55.6023 8.99426 55.8827 9.32857L55.2512 9.96123C54.7755 9.39207 54.1201 9.10809 53.2825 9.10809C52.5252 9.10809 51.871 9.3741 51.3186 9.90611C50.7662 10.4381 50.4906 11.1295 50.4906 11.9791C50.4906 12.8286 50.7662 13.52 51.3186 14.052C51.871 14.584 52.5252 14.85 53.2825 14.85C54.0853 14.85 54.7551 14.5828 55.2907 14.0472C55.6382 13.6985 55.8395 13.2132 55.8935 12.5913H53.2825V11.7274H56.7658C56.8017 11.9155 56.8173 12.0965 56.8173 12.2702Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3412 9.26752H59.0677V11.5466H62.0201V12.4105H59.0677V14.6895H62.3412V15.5738H58.1438V8.38443H62.3412V9.26752Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2365 15.5738H65.3127V9.26752H63.3045V8.38443H68.2448V9.26752H66.2365V15.5738Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8191 15.5738V8.38443H72.7429V15.5738H71.8191Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8398 15.5738H75.916V9.26752H73.9078V8.38443H78.8481V9.26752H76.8398V15.5738Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2 14.6452C87.493 15.3713 86.6147 15.7344 85.5639 15.7344C84.513 15.7344 83.6347 15.3713 82.929 14.6452C82.222 13.919 81.8697 13.03 81.8697 11.9791C81.8697 10.9283 82.222 10.0392 82.929 9.31305C83.6347 8.58692 84.513 8.22266 85.5639 8.22266C86.6087 8.22266 87.4858 8.58812 88.1952 9.31784C88.9045 10.0476 89.2592 10.9343 89.2592 11.9791C89.2592 13.03 88.9057 13.919 88.2 14.6452ZM83.6108 14.0425C84.1428 14.5817 84.7934 14.8501 85.5639 14.8501C86.3343 14.8501 86.9862 14.5805 87.517 14.0425C88.049 13.5033 88.3162 12.8155 88.3162 11.9791C88.3162 11.1427 88.049 10.455 87.517 9.91575C86.9862 9.37655 86.3343 9.10815 85.5639 9.10815C84.7934 9.10815 84.1428 9.37775 83.6108 9.91575C83.0799 10.455 82.8127 11.1427 82.8127 11.9791C82.8127 12.8155 83.0799 13.5033 83.6108 14.0425Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5557 15.5738V8.38443H91.6797L95.1737 13.9766H95.2132L95.1737 12.5914V8.38443H96.0975V15.5738H95.133L91.4772 9.70967H91.4376L91.4772 11.0948V15.5738H90.5557Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8173 12.2702C56.8173 13.2743 56.5201 14.0736 55.9246 14.6703C55.2488 15.3796 54.3669 15.7343 53.2837 15.7343C52.246 15.7343 51.3629 15.3748 50.638 14.6559C49.9119 13.9358 49.5488 13.0443 49.5488 11.9802C49.5488 10.915 49.9119 10.0235 50.638 9.3046C51.3629 8.58447 52.246 8.225 53.2837 8.225C53.7989 8.225 54.2914 8.32565 54.7587 8.52575C55.2272 8.72706 55.6023 8.99426 55.8827 9.32857L55.2512 9.96123C54.7755 9.39207 54.1201 9.10809 53.2825 9.10809C52.5252 9.10809 51.871 9.3741 51.3186 9.90611C50.7662 10.4381 50.4906 11.1295 50.4906 11.9791C50.4906 12.8286 50.7662 13.52 51.3186 14.052C51.871 14.584 52.5252 14.85 53.2825 14.85C54.0853 14.85 54.7551 14.5828 55.2907 14.0472C55.6382 13.6985 55.8395 13.2132 55.8935 12.5913H53.2825V11.7274H56.7658C56.8017 11.9155 56.8173 12.0965 56.8173 12.2702Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3412 9.26752H59.0677V11.5466H62.0201V12.4105H59.0677V14.6895H62.3412V15.5738H58.1438V8.38443H62.3412V9.26752Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2365 15.5738H65.3127V9.26752H63.3045V8.38443H68.2448V9.26752H66.2365V15.5738Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8191 15.5738V8.38443H72.7429V15.5738H71.8191Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8398 15.5738H75.916V9.26752H73.9078V8.38443H78.8481V9.26752H76.8398V15.5738Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2 14.6452C87.493 15.3713 86.6147 15.7344 85.5639 15.7344C84.513 15.7344 83.6347 15.3713 82.929 14.6452C82.222 13.919 81.8697 13.03 81.8697 11.9791C81.8697 10.9283 82.222 10.0392 82.929 9.31305C83.6347 8.58692 84.513 8.22266 85.5639 8.22266C86.6087 8.22266 87.4858 8.58812 88.1952 9.31784C88.9045 10.0476 89.2592 10.9343 89.2592 11.9791C89.2592 13.03 88.9057 13.919 88.2 14.6452ZM83.6108 14.0425C84.1428 14.5817 84.7934 14.8501 85.5639 14.8501C86.3343 14.8501 86.9862 14.5805 87.517 14.0425C88.049 13.5033 88.3162 12.8155 88.3162 11.9791C88.3162 11.1427 88.049 10.455 87.517 9.91575C86.9862 9.37655 86.3343 9.10815 85.5639 9.10815C84.7934 9.10815 84.1428 9.37775 83.6108 9.91575C83.0799 10.455 82.8127 11.1427 82.8127 11.9791C82.8127 12.8155 83.0799 13.5033 83.6108 14.0425Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5557 15.5738V8.38443H91.6797L95.1737 13.9766H95.2132L95.1737 12.5914V8.38443H96.0975V15.5738H95.133L91.4772 9.70967H91.4376L91.4772 11.0948V15.5738H90.5557Z",
    stroke: "white",
    strokeWidth: 0.239646,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_158_34744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.504 9.03278C12.1553 9.40184 11.9492 9.97459 11.9492 10.7163V37.2163C11.9492 37.9592 12.1553 38.5308 12.504 38.8999L12.5927 38.9861L27.4375 24.1413V23.9663V23.7914L12.5927 8.94531L12.504 9.03278Z",
    fill: "url(#paint0_linear_158_34744)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.385 29.0961L27.4375 24.1462V23.9713V23.7963L32.3862 18.8477L32.4976 18.9112L38.3606 22.2422C40.0345 23.1936 40.0345 24.7501 38.3606 25.7027L32.4976 29.0338L32.385 29.0961Z",
    fill: "url(#paint1_linear_158_34744)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_158_34744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4976 29.0301L27.4362 23.9687L12.5039 38.9023C13.0551 39.487 13.9669 39.5589 14.9938 38.9766L32.4976 29.0301Z",
    fill: "url(#paint2_linear_158_34744)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.4976 18.9066L14.9938 8.96129C13.9669 8.37775 13.0551 8.45084 12.5039 9.03558L27.4374 23.9691L32.4976 18.9066Z",
    fill: "url(#paint3_linear_158_34744)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_158_34744",
    x: 11.9492,
    y: 8.55859,
    width: 27.666,
    height: 30.8203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.179734
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_34744"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179734
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_158_34744",
    result: "effect2_innerShadow_158_34744"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_158_34744",
    x: 12.5039,
    y: 23.9688,
    width: 19.9941,
    height: 15.4102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.179734
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_34744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_34744",
    x1: 26.1216,
    y1: 10.4359,
    x2: 6.01295,
    y2: 30.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_158_34744",
    x1: 40.5395,
    y1: 23.9713,
    x2: 11.5473,
    y2: 23.9713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_158_34744",
    x1: 29.7489,
    y1: 26.7174,
    x2: 2.47904,
    y2: 53.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_158_34744",
    x1: 8.74314,
    y1: 0.213973,
    x2: 20.9199,
    y2: 12.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/GooglePlayStore.1aa5bc609e330070c36ce7ef938a0240.svg";
export { ForwardRef as ReactComponent };